import {rgba} from "polished";

import {designColors} from "~/ui";

import {BannerColorPresetType, IBannerColors} from "./types";

export const getColorsByPreset = (preset: BannerColorPresetType): IBannerColors => {
  switch (preset) {
    case "navy":
      return {
        backgroundColor: designColors.blue_1,
        borderColor: rgba(designColors.blue_3, 0.25),
        titleColor: designColors.colorInk,
      };
    case "red":
      return {
        backgroundColor: designColors.red_1,
        borderColor: rgba(designColors.red_3, 0.25),
        titleColor: designColors.colorInk,
      };
    case "yellow":
      return {
        borderColor: rgba(designColors.yellow_3, 0.25),
        backgroundColor: designColors.yellow_1,
        titleColor: designColors.colorInk,
      };
    case "green":
      return {
        borderColor: rgba(designColors.green_3, 0.25),
        backgroundColor: designColors.green_1,
        titleColor: designColors.colorInk,
      };
    case "lightGrey":
      return {
        backgroundColor: designColors.off_white,
        borderColor: designColors.grey_3,
        titleColor: designColors.colorInk,
      };
    case "default":
    default:
      return {
        backgroundColor: designColors.white,
        borderColor: designColors.grey_3,
        titleColor: designColors.colorInk,
      };
  }
};
